import React from "react";
// ANCHOR types
import { ILoginFormValues } from "../Types/form";
// ANCHOR api
// ANCHOR Components

import SignInWithPassword from "./signInWithPassword";

interface ILoginContainerState {
  checked: boolean;
  values: ILoginFormValues;
}

const LoginContainer = () => {
  // const { handleSubmit, register, formState, control, setValue } = useForm();
  // let history = useHistory();
  // const [number, setNumber] = useState<any>();
  // const [disabled, setDisabled] = useState(false);
  // const { t } = useTranslation();
  // // form elements handler
  // const submit = async (object: any) => {
  //   try {
  //     setDisabled(true);
  //     const { data } = await api.apiCall<BaseResponse<any>>("/sign-in", {
  //       phoneNumber:
  //         "+998" +
  //         number?.slice(0, 2) +
  //         number?.slice(3, 6) +
  //         number?.slice(7, 9) +
  //         number?.slice(10, 12),
  //     });
  //     browserStorage.set("hasPassword", data?.data.hasPassword.toString());
  //     browserStorage.set(
  //       "phoneNumber",
  //       "+998" +
  //         number?.slice(0, 2) +
  //         number?.slice(3, 6) +
  //         number?.slice(7, 9) +
  //         number?.slice(10, 12)
  //     );
  //     if (data) toast.success(t(`TOAST_MESSAGES.${baseErrors[data?.code]}`));
  //     if (data?.data.hasPassword) {
  //       history.push("/sign-with-password");
  //     } else {
  //       history.push("/sign-verify");
  //     }
  //   } catch (e: any) {
  //     if (e.response.data.code === 401) {
  //       localStorage.clear();
  //       history.push("/");
  //     }
  //     toast.error(t(`TOAST_MESSAGES.${baseErrors[e.response.data.code]}`));
  //   } finally {
  //     setDisabled(false);
  //   }
  // };

  return (
    <>
      <SignInWithPassword />
      {/* <Form
        handleSubmit={handleSubmit}
        register={register}
        formState={formState}
        control={control}
        setNumber={setNumber}
        onHandleSubmit={submit}
        disabled={disabled}
      /> */}
    </>
  );
};

export default LoginContainer;
